import React, {Component} from 'react';
import {Grid} from 'semantic-ui-react';

class FieldsHeader extends Component {
  renderLocationHeaders() {
    return (
      <Grid>
        <Grid.Row columns='5'>
          <Grid.Column textAlign='center'>Pasillo</Grid.Column>
          <Grid.Column textAlign='center'>Modulo</Grid.Column>
          <Grid.Column textAlign='center'>Nivel</Grid.Column>
          <Grid.Column textAlign='center'>Secuencial</Grid.Column>
          <Grid.Column textAlign='center'>BIN</Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }

  renderWarehouses() {
    const {warehouses} = this.props;

    return (
      <Grid>
        <Grid.Row columns={warehouses.length}>
          {warehouses.map((item) => {
            return (<Grid.Column textAlign='center' key={item.code}>
              {item.code}
            </Grid.Column>);
          })}
        </Grid.Row>
      </Grid>
    );
  }

  renderPickingZones() {
    const {zones} = this.props;

    return (
      <Grid>
        <Grid.Row columns={zones.length}>
          {zones.map((item) => {
            return (<Grid.Column textAlign='center' key={item.code}>
              {item.name}
            </Grid.Column>);
          })}
        </Grid.Row>
      </Grid>
    );
  }

  render() {
    return (
      <Grid>
        <Grid.Row verticalAlign='middle'>
          <Grid.Column width={5}>
            <div className='header'><h3>Ubicación Primaria</h3></div>
          </Grid.Column>
          <Grid.Column width={5}>
            <div className='header'><h3>Bodega</h3></div>
          </Grid.Column>
          <Grid.Column width={5}>
            <div className='header'><h3>Zona</h3></div>
          </Grid.Column>
          <Grid.Column width={1}></Grid.Column>
        </Grid.Row>
        <Grid.Row className='fields-headers' verticalAlign='middle'>
          <Grid.Column width={5}>
            <div className='header'>{this.renderLocationHeaders()}</div>
          </Grid.Column>
          <Grid.Column width={5}>
            <div className='header'>{this.renderWarehouses()}</div>
          </Grid.Column>
          <Grid.Column width={5}>
            <div className='header'>{this.renderPickingZones()}</div>
          </Grid.Column>
          <Grid.Column width={1}></Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default FieldsHeader;
